module.exports = __webpack_public_path__ + "static/Portfolio15-3dbdbf2de533354d5773bf6083630b39.jpg";